export default __webpack_public_path__ + "static/media/appIcon.95856ade.png";